document.loadSellers = function(){
  var xhr = new XMLHttpRequest();
  var url = PAGE_DATA.SSS_API_URLS.sellers_list_page + "?url=";
  xhr.open("GET", url + Shopify.shop);
  var success = true;
  xhr.onerror = function(){
    success = false;
  }
  xhr.onload = function(){ 
    if (success){
      var html = xhr.response;
      document.getElementById("vendors-list").innerHTML = html;
    }
  }
  xhr.send();
}